import { render, staticRenderFns } from "./SplaService.vue?vue&type=template&id=0e4f7187&"
import script from "./SplaService.vue?vue&type=script&lang=js&"
export * from "./SplaService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports